import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';

// PrivateRoute — protege rutas según la sesión que ya tiene AuthContext.
//
// IMPORTANTE: NO hace una verificación de red (supabase.auth.getUser()) para
// renderizar. Antes lo hacía en un useEffect al montar y esa llamada
// bloqueante —sin timeout— dejaba la ruedita girando para siempre si la
// request se demoraba al volver de una pestaña en background (era la causa de
// "entro a Noticias y se queda girando"). La seguridad real la aplica Supabase
// con RLS en CADA query del servidor; acá solo decidimos qué mostrar en el
// cliente según la sesión ya cargada (persistida en localStorage).
export default function PrivateRoute({ children, requireRole }) {
  const { user, userRole, loading } = useAuth();

  // Spinner SOLO durante la carga inicial de la sesión (instantánea si hay
  // sesión persistida). No depende de ninguna request de red, así que no se
  // puede colgar al cambiar de pestaña.
  if (loading) {
    return (
      <div style={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--color-soft)',
      }}>
        <div style={{
          width: 44, height: 44,
          border: '3px solid rgba(32,32,160,.2)',
          borderTop: '3px solid var(--color-primary)',
          borderRadius: '50%',
          animation: 'spinAnim .7s linear infinite',
        }} />
      </div>
    );
  }

  // Sin sesión → redirigir al login
  if (!user) return <Navigate to="/auth/login" replace />;

  // Con rol requerido → verificar que el usuario tiene ese rol
  if (requireRole && userRole !== requireRole) {
    return <Navigate to="/" replace />;
  }

  return children;
}
